import { Injectable } from '@angular/core';
import { BlocklyParser } from '@shared/blockly/core/parser';
import { BlockSearchService } from 'src/app/shared/services/block-search.service';
import { registerBlockTooltip, registerDeprecatedBlock } from './blockly-toolbox-search-de';
import './register-fields';

@Injectable({
  providedIn: 'root'
})
export class BlocklyParserService extends BlocklyParser {
  constructor(blockSearch: BlockSearchService) {
    super({
      searchSink: (entry) => blockSearch.register(entry),
      registerBlockTooltip,
      registerDeprecatedBlock
    });
  }
}
